import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70573059"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item" }
const _hoisted_2 = { class: "item-title" }
const _hoisted_3 = { class: "item-indicator" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CircleProgress = _resolveComponent("CircleProgress")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", null, _toDisplayString(_ctx.courseTrack.title), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_CircleProgress, {
        class: "item-progress",
        done: _ctx.courseTrack.finishedCourses,
        total: _ctx.courseTrack.totalCourses
      }, null, 8, ["done", "total"]),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.courseTrack.finishedCourses) + "/" + _toDisplayString(_ctx.courseTrack.totalCourses) + " finalizados ", 1),
      _createElementVNode("span", {
        class: _normalizeClass(["item-icon", { rotated: _ctx.activeCourseTrackID === _ctx.courseTrack.id }])
      }, null, 2)
    ])
  ]))
}